import { EMAILS_DIMENSIONS_WHITE_LIST } from '../../../../../../shared/constants/emailsDimensionsWhiteList';
import { NativeQueriesService } from '../../../../../../shared/NativeQueries.service';
import { ALL_EVENT_NAMES } from '../../../../common/support/eo_mapping';
import { COST } from '../../../../common/support/eo_mapping/datasources';
import { parseFiltersFromQueryString } from '../../../../common/support/utils';

export const EMAIL_FILTERS_LIST = [...EMAILS_DIMENSIONS_WHITE_LIST];

// Events in "Show:" dropdown for the query builder
export const EMAIL_EVENT_LIST = Object.keys(ALL_EVENT_NAMES).filter(
  (e) => e !== 'IMPRESSION' && e !== 'CTA_VIEW' && e !== COST
);

export const getFilter = (filters: string | string[] | null) =>
  filters &&
  new NativeQueriesService().convertFiltersToNativeDruidFilters({
    filters: parseFiltersFromQueryString(filters),
  });
